import { request } from '@umijs/max';
import ENV from '@/conf/env';
import { DictScene } from '@/utils/types/common';
import AdminSysDict from '@/services/admin/Sys/AdminSysDict';
import { SysDict, SysOrgNode, SysRegionNode, UmsOrgKindNode } from '@/services/admin/AdminTypings';
import AdminSysRegion from '@/services/admin/Sys/AdminSysRegion';
import AdminUmsOrgKind from '@/services/admin/Ums/AdminUmsOrgKind';
import AdminSysOrg from '@/services/admin/Sys/AdminSysOrg';

export namespace CommonService {
  export const staticData = async <T>(url: string, opts: any = { method: 'GET' }) => {
    if (!url.startsWith('http')) {
      url = `${ENV.staticHost}/data/${ENV.staticEnv}${url}`;
    }
    return request<T>(url, {
      baseURL: ENV.staticHost,
      method: 'GET',
      skipErrorHandler: true,
      withCredentials: false,
      getResponse: true,
      ...opts,
      params: {
        ...(opts.params || {}),
        t: Math.random(),
      },
    });
  };

  export const dictInfo = async (
    scene: DictScene,
    code: string,
    params: { [key: string]: any } = {},
  ): Promise<SysDict> => {
    try {
      // @ts-ignore
      return await staticData<SysDict>(`/sys/dict/${scene}/${code}.json`, params);
    } catch (e) {
      return await AdminSysDict.dictInfoByCode(scene, code, params);
    }
  };

  export const dictChildren = async (
    scene: DictScene,
    code: string,
    params: { [key: string]: any } = {},
  ) => {
    try {
      const dictData = await dictInfo(scene, code, params);
      if (dictData && (('children' in dictData && dictData.children) || []).length > 0) {
        return 'children' in dictData ? dictData.children : [];
      }
    } catch (e) {
      //console.error('staticDict error:', e);
    }
    return [];
  };

  export const queryRegions = async (pkg?: string): Promise<SysRegionNode[] | undefined> => {
    try {
      // @ts-ignore
      return await staticData(`/sys/region/${(pkg || 'ZH').toUpperCase()}/areas.json`);
    } catch (e) {
      // @ts-ignore
      return AdminSysRegion.treeNode((pkg || 'ZH').toUpperCase());
    }
  };

  export const queryOrgKinds = async (): Promise<UmsOrgKindNode[] | undefined> => {
    try {
      // @ts-ignore
      return await staticData('/ums/org/kinds.json');
    } catch (e) {
      // @ts-ignore
      return AdminUmsOrgKind.treeNode();
    }
  };

  export const querySysOrg = async (): Promise<SysOrgNode[] | undefined> => {
    try {
      // @ts-ignore
      return await staticData('/sys/org/treeNode.json');
    } catch (e) {
      return AdminSysOrg.treeNodeQuery();
    }
  };

  export const querySysOrgDepartment = async (): Promise<SysOrgNode[] | undefined> => {
    try {
      // @ts-ignore
      return await staticData('/sys/org/treeDepartment.json');
    } catch (e) {
      return AdminSysOrg.treeNodeDepartment();
    }
  };

  export const querySysOrgChild = async (): Promise<SysOrgNode[] | undefined> => {
    try {
      // @ts-ignore
      return await staticData('/sys/org/treeChild.json');
    } catch (e) {
      return AdminSysOrg.treeNodeChild();
    }
  };
}

export const staticData = CommonService.staticData;
export const dictInfo = CommonService.dictInfo;
export const dictChildren = CommonService.dictChildren;
export const queryRegions = CommonService.queryRegions;
export const queryOrgKinds = CommonService.queryOrgKinds;

export const querySysOrg = CommonService.querySysOrg;
export const querySysOrgDepartment = CommonService.querySysOrgDepartment;
export const querySysOrgChild = CommonService.querySysOrgChild;
